import React from 'react'
import Container from "../Container"


import "./Footer.css"
const Footer = () => {
    return (

        <Container >
            <footer className="pb-4 text-center footer" id="footer">
                <p>Copyright 2022, Developed by Osama. All Rights Reserved</p>
            </footer>
        </Container>

    )
}

export default Footer